import {
  PlanStack,
  PlanType,
  PlanV2,
} from '@zapier/design-system-revenue/src/types';

import { freePlanStackMock } from './plan.free.mock';
import { starterPlanStackMock } from './plan.starter.mock';
import { professionalPlanStackMock } from './plan.professional.mock';
import { teamPlanStackMock } from './plan.team.mock';
import { companyPlanStackMock } from './plan.company.mock';

const planStackMocks: Array<PlanStack> = [
  freePlanStackMock,
  starterPlanStackMock,
  professionalPlanStackMock,
  teamPlanStackMock,
  companyPlanStackMock,
];

export const mockPlanStack = (type: PlanType): PlanStack => {
  const planStack = planStackMocks.find(stack => stack.planType === type);

  if (!planStack || !planStack.plans || planStack.plans.length === 0) {
    throw new Error(`Unable to find mock for plan type \`${type}\`.`);
  }

  return planStack;
};

export const mockPlanStacks = (): Array<PlanStack> => planStackMocks;

export const mockPlan = (
  type: PlanType,
  options: Partial<PlanV2> = {}
): PlanV2 => {
  const planStack = mockPlanStack(type);
  return { ...planStack.plans[0], ...options };
};

export const mockFreePlan = (options: Partial<PlanV2> = {}) =>
  mockPlan('Free', options);

export const mockStarterPlan = (options: Partial<PlanV2> = {}) =>
  mockPlan('Starter', options);

export const mockProfessionalPlan = (options: Partial<PlanV2> = {}) =>
  mockPlan('Professional', options);

export const mockTeamPlan = (options: Partial<PlanV2> = {}) =>
  mockPlan('Team', options);

export const mockCompanyPlan = (options: Partial<PlanV2> = {}) =>
  mockPlan('Company', options);

export const mockCurrentPlan = (
  type: PlanType,
  options: Partial<PlanV2> = {}
) => ({ ...mockPlan(type, options), isCurrentPlan: true });
